import { Component } from '@angular/core';
import { ModalService } from '../modal.service';
declare var $:any;
/**
 * This class represents the information modal component
 */
@Component({
    selector: 'alert-modal',
    templateUrl: 'alert-modal.component.html',
    standalone: false
})

export class AlertModalComponent {

	translateSrc: string;

	constructor(modalService: ModalService) {
		// modalService.alert = this.alert.bind(this);
		modalService.alert$.subscribe(msg => this.alert(msg));
	}

	alert(msgKey: string): void {
		this.translateSrc = msgKey;
		$('#alertModal').modal();
	}

}
